import {put, takeLatest, call} from 'redux-saga/effects';
import * as paymentService from "../../../services/paymentService";
import {
    CANCEL_PROVISION,
    CANCEL_PROVISION_SUCCESS,
    CANCEL_PROVISION_ERROR,
}
    from "../../actions/payment"

function* cancelProvision(action) {
    try {
       const data  = yield call(paymentService.CancelProvision,action.payload)
       yield put({
        type: CANCEL_PROVISION_SUCCESS,
        payload: data
    })


    } catch (error) {
        yield put({
            type: CANCEL_PROVISION_ERROR,error: error.data
        })
    }
}


export function* cancelProvisionWatcher() {
    yield takeLatest(CANCEL_PROVISION, cancelProvision)
}